export default "__VITE_ASSET__DZ3WAi7x__"